const LINK = "https://smartlex.onrender.com";
// const LINK = "http://127.0.0.1:5000";

export default LINK;